// extracted by mini-css-extract-plugin
module.exports = {"exitButton":"messages__exitButton___149M2","messagesWrapper":"messages__messagesWrapper___3yHjr","header":"messages__header___20VLu","messages":"messages__messages___1cHDY"};